const lips = [  require('../../images/crazy/lips/1.png'), require('../../images/crazy/lips/2.png'),
                require('../../images/crazy/lips/3.png'), require('../../images/crazy/lips/4.png'),
                require('../../images/crazy/lips/5.png'), require('../../images/crazy/lips/6.png'),
                require('../../images/crazy/lips/7.png')];

const zombieGIFPos = [  require('../../images/crazy/zombie/pos/1.png'), require('../../images/crazy/zombie/pos/2.png'), 
                        require('../../images/crazy/zombie/pos/3.png'), require('../../images/crazy/zombie/pos/4.png'),
                        require('../../images/crazy/zombie/pos/5.png'), require('../../images/crazy/zombie/pos/6.png'), 
                        require('../../images/crazy/zombie/pos/7.png'), require('../../images/crazy/zombie/pos/8.png'),
                  ];

const zombieGIFNeg = [  require('../../images/crazy/zombie/neg/1.png'), require('../../images/crazy/zombie/neg/2.png'), 
                        require('../../images/crazy/zombie/neg/3.png'), require('../../images/crazy/zombie/neg/4.png'),
                        require('../../images/crazy/zombie/neg/5.png'), require('../../images/crazy/zombie/neg/6.png'), 
                        require('../../images/crazy/zombie/neg/7.png'), require('../../images/crazy/zombie/neg/8.png'),
            ];

const face = [ require('../../images/crazy/face/1.png')];
module.exports = {
    lips, zombieGIFPos, zombieGIFNeg, face
}